import React, { useState, useEffect } from "react";

interface CarouselProps {
  images: string[];
  interval: number;
  className: string;
}

const Carousel: React.FC<CarouselProps> = ({ images, interval, className }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(goToNextImage, interval);
    return () => clearInterval(timer);
  }, []);

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div>
      <img
        src={images[currentImageIndex]}
        alt="Carousel Image"
        className={className + ``}
      />
    </div>
  );
};

export default Carousel;
